<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button parkourBackButton />
    </ion-buttons>

    <ion-title>{{ 'team.teamlid-details-edit-page.title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <ng-container *parkourShowIfSuccessful="mainPageData$ | async; let data">
        @if (data.teamlid.status === 'ACTIEF') {
          <parkour-header-action
            [label]="'team.teamlid-details-edit-page.teamlid-save' | translate"
            form="teamlid-form"
            icon="disk"
            testId="submit"
            type="submit"
          />
        }
      </ng-container>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <parkour-page-layout>
    <ng-container *parkourPageContent="mainPageData$ | async; refresh: 'none'; let data">
      @switch (data.teamlid.status) {
        @case ('ACTIEF') {
          <div class="flex flex-col h-full">
            <parkour-profiel-details [profiel]="data.teamlid">
              @if (detailsEditForm$ | async; as detailsEditForm) {
                <form
                  typeContent
                  (ngSubmit)="onDetailsSubmit(detailsEditForm)"
                  class="w-full"
                  id="teamlid-form"
                >
                  <parkour-form-field
                    [inputFormControl]="detailsEditForm.controls.rol"
                    [label]="'profiel.relatie' | translate"
                    [required]="true"
                    class="block"
                    inputId="rol"
                  >
                    <parkour-select
                      [formControl]="detailsEditForm.controls.rol"
                      [options]="rolOptions"
                      placeholder=""
                      selectId="rol"
                    >
                    </parkour-select>
                  </parkour-form-field>
                </form>
              }
              @if (data.teamlid.verificatieStatus === 'GEVERIFIEERD') {
                <parkour-profiel-details-geverifieerd-card topCardContent />
              }
            </parkour-profiel-details>
            <parkour-teamlid-details-edit-bottom-section
              [teamlid]="data.teamlid"
              (verwijderClick)="isVerwijderTeamlidPopupOpen = true"
              (activeerClick)="isActiveerTeamlidPopupOpen = true"
              (blokkeerClick)="isBlokkeerTeamlidPopupOpen = true"
            />
          </div>
        }
        @case ('GEBLOKKEERD') {
          <parkour-page-with-gradient-hero [title]="data.teamlid | profielnaam">
            <parkour-profiel-foto class="block" hero-image [profiel]="data.teamlid" [size]="'10'" />
            <parkour-teamlid-details-edit-bottom-section
              class="flex-1 flex flex-col"
              [teamlid]="data.teamlid"
              (verwijderClick)="isVerwijderTeamlidPopupOpen = true"
              (activeerClick)="isActiveerTeamlidPopupOpen = true"
              (blokkeerClick)="isBlokkeerTeamlidPopupOpen = true"
            />
          </parkour-page-with-gradient-hero>
        }
      }
    </ng-container>
  </parkour-page-layout>
</ion-content>

<parkour-popup
  (hasBeenDismissed)="isVerwijderTeamlidPopupOpen = false"
  [isOpen]="isVerwijderTeamlidPopupOpen"
  icon="trash"
>
  <div content>
    <p class="typo-body variant-body-fat">Teamlid verwijderen</p>

    <p>Ben je zeker dat je dit teamlid wilt verwijderen?</p>
  </div>

  <div class="flex items-center gap-x-4" footer>
    <parkour-button
      (clicked)="isVerwijderTeamlidPopupOpen = false"
      class="w-full"
      variant="tertiary"
    >
      {{ 'buttons.nee' | translate }}
    </parkour-button>

    <parkour-button (clicked)="verwijderPressed()" class="w-full">
      {{ 'buttons.ja' | translate }}
    </parkour-button>
  </div>
</parkour-popup>

<parkour-popup
  (hasBeenDismissed)="isActiveerTeamlidPopupOpen = false"
  [isOpen]="isActiveerTeamlidPopupOpen"
  icon="check"
>
  <div content>
    <p class="typo-body variant-body-fat">Wil je jouw teamlid activeren?</p>

    <p>
      Je teamlid zal jouw profiel kunnen lezen, berichten sturen en reageren. Je teamlid zal enkel
      gebeurtenissen en doelen zien die met hele team of hen specifiek zijn gedeeld.
    </p>
  </div>

  <div class="flex items-center gap-x-4" footer>
    <parkour-button
      (clicked)="isActiveerTeamlidPopupOpen = false"
      class="w-full"
      variant="tertiary"
    >
      {{ 'buttons.nee' | translate }}
    </parkour-button>

    <parkour-button (clicked)="activeer()" class="w-full">
      {{ 'buttons.ja' | translate }}
    </parkour-button>
  </div>
</parkour-popup>

<parkour-popup
  (hasBeenDismissed)="isBlokkeerTeamlidPopupOpen = false"
  [isOpen]="isBlokkeerTeamlidPopupOpen"
  icon="cross"
>
  <div content>
    <p class="typo-body variant-body-fat">Wil je jouw teamlid blokkeren?</p>

    <p>
      Je teamlid zal geen toegang hebben tot jouw profiel, berichten, verhaal en doelen tot je hen
      terug actief zet.
    </p>
  </div>

  <div class="flex items-center gap-x-4" footer>
    <parkour-button
      (clicked)="isBlokkeerTeamlidPopupOpen = false"
      class="w-full"
      variant="tertiary"
    >
      {{ 'buttons.nee' | translate }}
    </parkour-button>

    <parkour-button (clicked)="blokkeer()" class="w-full">
      {{ 'buttons.ja' | translate }}
    </parkour-button>
  </div>
</parkour-popup>
